import {getAllThreadsV2} from 'src/appApi';
import {SET_THREADS} from '../actionNames';
import {setAppState} from '../app/app.actions';
import {AppReducerStates, NotificationType} from '../app/app.reducer';
import {ThreadsStateType} from './threads.reducer';
import {parseSingleThread} from './threads.utils';

const setThreads = (payload: Pick<ThreadsStateType, 'threads'>) => {
  return {
    type: SET_THREADS,
    payload,
  };
};

export const fetchThreads = (userId: number, year: number) => {
  return async (dispatch: any) => {
    try {
      const {data} = await getAllThreadsV2({
        fly_user_id: userId,
        year,
      });
      const threads = data.map((threadData) => {
        const returnThreads = threadData.threads.map(parseSingleThread);
        return {
          ...threadData,
          threads: returnThreads,
        };
      });

      dispatch(setThreads({threads}));
    } catch (e) {
      dispatch(
        setAppState(AppReducerStates.notifcationStatus, {
          isVisible: true,
          message: `Failed to get threads (${e})`,
          type: NotificationType.error,
        }),
      );
    }
  };
};
